import Link from 'components/styled/link/styled';

export default Link;
